var exports = {
  "kX": "PurchaseHistoryStatus.module__success___ZS1WQn",
  "Ub": "PurchaseHistoryStatus.module__pending___ZS1WQn",
  "SU": "PurchaseHistoryStatus.module__muted___ZS1WQn",
  "SY": "PurchaseHistoryStatus.module__neutral___ZS1WQn",
  "OR": "PurchaseHistoryStatus.module__danger___ZS1WQn",
};

module.exports = exports;
